import { API_URL } from '@config';
import generateSHA256Hash from '@utils/crypto';

interface FileInfo {
  presignedUrl: string;
  fileName: string;
  fileType: string;
}

const getFileInfo = async (
  filePath: string,
  s3Url?: string
): Promise<FileInfo | null> => {
  const parts = filePath?.split('|');
  const fileId = parts?.[0] || '';
  const accessKey = parts?.[1] || '';

  if (!((fileId && accessKey) || s3Url)) return null;

  try {
    const signature = await generateSHA256Hash(`${fileId}|${accessKey}`);
    const redirectUrl =
      s3Url ||
      `${API_URL}/_files/download/${fileId}/${accessKey}?signature=${signature}&isExport=false`;

    const presignedResponse = await fetch(redirectUrl).then((res) =>
      res.json()
    );

    if (!presignedResponse) return null;

    const presignedUrl =
      typeof presignedResponse === 'string'
        ? presignedResponse
        : presignedResponse?.url || presignedResponse?.presignedUrl;

    if (!presignedUrl) return null;

    const fileNameFromResponse =
      typeof presignedResponse === 'object'
        ? presignedResponse?.fileName ||
          presignedResponse?.filename ||
          presignedResponse?.name
        : undefined;

    const fileName =
      fileNameFromResponse ||
      decodeURIComponent(
        presignedUrl?.split('/').pop()?.split('?')?.[0] || fileId
      );

    const extension = fileName.includes('.')
      ? fileName?.split('.').pop()?.toLowerCase() || ''
      : '';

    return { presignedUrl, fileName, fileType: extension };
  } catch {
    return null;
  }
};

export default getFileInfo;
